import { superAdminAnalyticsControllerApi } from "@/lib/api"
import type { ApiResponseLeakTrendsDTO, LeakTrendsDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetLeakTrends = (from?: string, to?: string) => {
  return useQuery({
    queryKey: [useGetLeakTrends.QUERY_KEY, from, to],
    queryFn: async () => {
      const response = await superAdminAnalyticsControllerApi.getLeakTrends(from, to)
      return (response.data as ApiResponseLeakTrendsDTO).data as LeakTrendsDTO
    },
  })
}

useGetLeakTrends.QUERY_KEY = "leak-trends"

export default useGetLeakTrends
